import Control from "../../../../../common/Controls/Control";
import useRCPROQuestion from "./useRCPROQuestion";

const RCPROSante = ({ company }) => {
  const { updateRcproData, onBlur, errors, inputsConfig, formState } =
    useRCPROQuestion({ company });
  return (
    <div>
      <Control
        label={inputsConfig.santeEmploiPersonnelMedical.label}
        type="btnList"
        name="santeEmploiPersonnelMedical"
        value={company.RCPRO.santeEmploiPersonnelMedical}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.santeEmploiPersonnelMedical.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
      <Control
        label={inputsConfig.santeActesSousAutorisation.label}
        type="btnList"
        name="santeActesSousAutorisation"
        value={company.RCPRO.santeActesSousAutorisation}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.santeActesSousAutorisation.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
      <Control
        label={inputsConfig.santeConventionOrganismesSante.label}
        type="btnList"
        name="santeConventionOrganismesSante"
        value={company.RCPRO.santeConventionOrganismesSante}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.santeConventionOrganismesSante.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
    </div>
  );
};

export default RCPROSante;
